import { useAuth } from '../contexts/AuthContext';
import { resolveClientTimeZone } from '../utils/clientTimezone';

export function useClientTimeZone(): string {
  const { client } = useAuth();
  return resolveClientTimeZone(client?.address?.country, client?.address?.state_province);
}
